export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'f9752120-83d3-4e63-b905-c0988dce1fc1';
export const MODAL_CLOSE_SEC = 2.5;
